module.exports = __webpack_public_path__ + "static/media/Hair Clip.ffea28ef.svg";